const LOAD_GLOBAL_TEMPLATES = (state, payload) => {
    state.globalTemplates = payload;
};

export default {
    LOAD_GLOBAL_TEMPLATES,
};
